import type { ApiSchemas } from '@rental/contracts/client'
import { formatEuro } from '@rental/i18n'
import { cn } from '@rental/ui'
import { useLocale } from '../i18n'

/**
 * UI-1c: the account at a glance: what was paid and what is owed either way.
 * The sum behind it (the total, what the return added, refunds) is in the
 * booking's account pane. Under a booking's title, and beside the hand-over's
 * button, where it is information and never a reason to wait.
 */
export function MoneyStrip({
  money,
  className,
}: {
  money: ApiSchemas['StaffMoney']
  className?: string
}) {
  const { locale, messages: m } = useLocale()
  const owed =
    money.balanceCents > 0
      ? m.money.balance
      : money.balanceCents < 0
        ? m.money.credit
        : m.money.settled
  return (
    <dl
      data-testid="money-strip"
      className={cn('flex flex-wrap gap-x-8 gap-y-3 border-t border-rule pt-4', className)}
    >
      <div className="flex flex-col">
        <dt className="text-sm text-text-muted">{m.money.paid}</dt>
        <dd className="figures text-xl">{formatEuro(money.paidCents, locale)}</dd>
      </div>
      <div className="flex flex-col">
        <dt className="text-sm text-text-muted">{owed}</dt>
        <dd className="figures text-xl font-bold">
          {formatEuro(Math.abs(money.balanceCents), locale)}
        </dd>
      </div>
    </dl>
  )
}
